import { render, staticRenderFns } from "./ProductItemDetail.vue?vue&type=template&id=0624379e&"
import script from "./ProductItemDetail.vue?vue&type=script&lang=js&"
export * from "./ProductItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports